import type { DateParameter } from "~/graphql/supergraphTypes";

/**
 * Copy for the placeholder shown while a required date has no value yet.
 *
 * Phrased from how many dates the query asks for rather than assuming a
 * begin/end pair: one query wants a single report date, another a pair, another
 * several unrelated dates, and "date range" is wrong for all but the pair. The
 * dates themselves aren't named here because the labelled inputs are already on
 * screen beside the placeholder.
 */
export const missingDatesPrompt = (required: readonly DateParameter[]) =>
  required.length === 1
    ? {
        title: "Select a date to preview",
        description: "This template needs a date you choose each time it runs.",
      }
    : {
        title: "Select dates to preview",
        description: "This template needs dates you choose each time it runs.",
      };
